import { Grid } from '@mui/material'
import Button from '../../../../shared/UI/Button'
import HolidaysEmployeeRequestBulgariaDetail from './HolidaysEmployeeRequestBulgariaDetail'
import HolidaysEmployeeRequestBulgariaDetailGrid from './HolidaysEmployeeRequestBulgariaDetailGrid'
import { DetailTabProps } from './types'
import Tab from '../../../../shared/UI/Tab'

function HolidaysEmployeeRequestBulgariaDetailTab({ data, onClose }: DetailTabProps) {
  const tabs: any[] = [
    {
      label: 'Info',
      tabContext: <HolidaysEmployeeRequestBulgariaDetail data={data} />,
      disabled: false,
    },
    {
      label: 'Requested Days',
      tabContext: <HolidaysEmployeeRequestBulgariaDetailGrid data={data.groupInfo} />,
      disabled: false,
    },
  ]

  return (
    <div style={{ paddingLeft: '30px' }}>
      <Tab titleAndContent={tabs} />
      <Grid
        container
        xl={12}
        pl={4}
        pr={4}
        style={{ paddingLeft: '60px', position: 'fixed', bottom: '40px', right: '0px' }}
      >
        <Grid item xs={12} gap={4} display="flex" justifyContent="flex-end">
          <Button label="Close" color="secondary" variant="outlined" onClick={onClose} />
        </Grid>
      </Grid>
    </div>
  )
}

export default HolidaysEmployeeRequestBulgariaDetailTab
